export default "__VITE_ASSET__49d657bc__"